import type { WidgetSpec } from '@developerz/domain';
import { type JSX, Show } from 'solid-js';
import type { DashboardWidgetView } from '../lib/dashboards';
import { DataWidget } from './DataWidget';
import { MarkdownWidget } from './widgets/MarkdownWidget';
import { WidgetFrame } from './widgets/WidgetFrame';

// One placed widget (arc 101 slice 09, task #81): the card frame + either the
// static markdown body or a data widget (which owns its own fetch). Splitting
// markdown out here keeps the data path (pager + kind dispatch) in <DataWidget/>
// and lets markdown skip it entirely — it carries no query.
function markdownContent(spec: WidgetSpec): string | null {
  return spec.kind === 'markdown' ? spec.content : null;
}

export function WidgetView(props: {
  dashboardId: string;
  widget: DashboardWidgetView;
  token: string | null;
}): JSX.Element {
  return (
    <WidgetFrame title={props.widget.spec.title} kind={props.widget.spec.kind}>
      <Show
        when={markdownContent(props.widget.spec)}
        fallback={
          <DataWidget dashboardId={props.dashboardId} widget={props.widget} token={props.token} />
        }
      >
        {(content) => <MarkdownWidget content={content()} />}
      </Show>
    </WidgetFrame>
  );
}
